import { useNavigate, useParams } from 'react-router-dom';
import { ItemForm } from '../components/ItemForm';
import { useFoundItem, useUpdateFoundItem } from '../hooks/useFoundItems';

export function EditItemPage() {
	const { id } = useParams<{ id: string }>();
	const navigate = useNavigate();
	const { data: item, isLoading } = useFoundItem(id ?? '');
	const updateMutation = useUpdateFoundItem();

	if (isLoading) {
		return (
			<div className="min-h-screen bg-gray-50">
				<header className="sticky top-0 z-30 bg-white border-b border-gray-200">
					<div className="max-w-4xl mx-auto px-4 h-16 flex items-center justify-between">
						<h1 className="text-lg font-semibold text-gray-900">Editar Item</h1>
					</div>
				</header>
				<main className="max-w-2xl mx-auto px-4 py-8">
					<div className="bg-white border border-gray-200 rounded-lg p-6 animate-pulse space-y-4">
						<div className="h-10 bg-gray-200 rounded" />
						<div className="h-20 bg-gray-200 rounded" />
						<div className="h-10 bg-gray-200 rounded" />
						<div className="h-10 bg-gray-200 rounded" />
					</div>
				</main>
			</div>
		);
	}

	if (!item) {
		return (
			<div className="min-h-screen bg-gray-50 flex items-center justify-center">
				<p className="text-gray-600">Item não encontrado</p>
			</div>
		);
	}

	return (
		<div className="min-h-screen bg-gray-50">
			<header className="sticky top-0 z-30 bg-white border-b border-gray-200">
				<div className="max-w-4xl mx-auto px-4 h-16 flex items-center justify-between">
					<h1 className="text-lg font-semibold text-gray-900">Editar: {item.title}</h1>
				</div>
			</header>
			<main className="max-w-2xl mx-auto px-4 py-8">
				<div className="bg-white border border-gray-200 rounded-lg p-6">
					<ItemForm
						initialValues={{
							title: item.title,
							description: item.description ?? '',
							categoryId: item.categoryId,
							photoUrl: item.photoUrl,
							foundLocationText: item.foundLocationText,
							foundLatitude: item.foundLatitude?.toString() ?? '',
							foundLongitude: item.foundLongitude?.toString() ?? '',
						}}
						onSubmit={(data) => {
							updateMutation.mutate(
								{
									id: item.id,
									data: {
										title: data.title,
										description: data.description || undefined,
										categoryId: data.categoryId,
										photoUrl: data.photoUrl,
										foundLocationText: data.foundLocationText,
										foundLatitude: data.foundLatitude ? Number(data.foundLatitude) : null,
										foundLongitude: data.foundLongitude ? Number(data.foundLongitude) : null,
									},
								},
								{
									onSuccess: () => navigate(`/items/${item.id}`),
								},
							);
						}}
						isPending={updateMutation.isPending}
						submitLabel="Salvar alterações"
					/>
				</div>
			</main>
		</div>
	);
}
